
export const SYSTEM_ADMIN_EMAILS = [
  'melissa@ruthfam.com',
  'david@ruthfam.com',
  'melissaeruth@gmail.com'
];

/**
 * Checks if a user profile or email belongs to a system administrator.
 * @param profileOrEmail UserProfile object or email string
 * @returns boolean
 */
export function isSystemAdmin(profileOrEmail: any): boolean {
  if (!profileOrEmail) return false;
  
  const email = typeof profileOrEmail === 'string' 
    ? profileOrEmail 
    : profileOrEmail.email;
    
  if (!email) return false;
  
  const normalizedEmail = email.toLowerCase().trim();
  const isHardcodedAdmin = SYSTEM_ADMIN_EMAILS.some(
    adminEmail => adminEmail.toLowerCase().trim() === normalizedEmail
  );
  
  if (isHardcodedAdmin) return true;
  
  // Also check for role if it's a profile object
  if (typeof profileOrEmail === 'object' && profileOrEmail.roles) {
    return profileOrEmail.roles.includes('admin');
  }
  
  return false;
}

/**
 * Checks if a user has User Manager permissions.
 * @param profile UserProfile object
 * @returns boolean
 */
export function isUserManager(profile: any): boolean {
  if (!profile) return false;
  if (isSystemAdmin(profile)) return true;
  
  return profile.roles?.some((r: string) => ['admin', 'user_manager'].includes(r)) || false;
}

/**
 * Checks if a user has Department Lead permissions.
 * @param profile UserProfile object
 * @returns boolean
 */
export function isDeptLead(profile: any): boolean {
  if (!profile) return false;
  if (isSystemAdmin(profile)) return true;
  
  return profile.roles?.some((r: string) => ['admin', 'dept_lead'].includes(r)) || false;
}
